import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import SettingsSidebar from '../components/SettingsSidebar';

const SettingsScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Open the sidebar when the route is accessed
    // The sidebar will be managed by TopBar, but we can trigger it here if needed
  }, []);

  return (
    <AppLayout>
      <SettingsSidebar 
        open={true} 
        onClose={() => navigate('/admin/')} 
      />
    </AppLayout>
  );
};

export default SettingsScreen;

